import React from "react";
import ModalLayout from "../../../../../components/ModalLayout";
import { Box, Typography, useTheme } from "@mui/material";
import CarCancle from "../../../../../../media/images/icons/car-cancle";
import { blueGrey, grey } from "@mui/material/colors";
import CustomButton from "../../../../../components/CustomButton";
import CloseCircleSVG from "../../../../../../media/images/icons/close-icon";

import { useAppSelector } from "../../../../../../hooks/useRedux";
import TruckFillSVG from "../../../../../../media/images/icons/truck-fill";
import BuildingSVG from "../../../../../../media/images/icons/building-icon";
import PeopleSVG from "../../../../../../media/images/icons/people-svg";
import UserCheckSVG from "../../../../../../media/images/icons/user-check";

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onOk: () => void;
  onDismiss: () => void;
}

export default function CheckinCancelModal(props: Props) {
  const { open, setOpen, onOk, onDismiss } = props;

  const theme = useTheme();

  const { vehicleInfo, driverNobatQueueInfo } = useAppSelector(
    (state) => state.user
  );

  const themeMode = useAppSelector((state) => state.settings.themeMode);

  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Box
        sx={{
          display: "flex ",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CarCancle color={theme.palette.error.main} />
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              color: "error.main",
              mb: 1,
            }}
          >
            لغو نوبت
          </Typography>
        </Box>
        <Box
          sx={{
            borderColor: blueGrey[100],
            border: "0.5px solid",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <TruckFillSVG color={themeMode === "light" ? grey[800] : "#fff"} />
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "12px",
              }}
            >
              {vehicleInfo?.loaderTypeName}
            </Typography>
          </Box>
          <hr
            style={{
              border: "1px dashed grey",
              transform: "rotate(90deg)",
              width: "14px",
            }}
          />
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "12px",
            }}
          >
            {vehicleInfo?.loaderTypeGroup}
          </Typography>
        </Box>
        <Box
          sx={{
            borderColor: blueGrey[100],
            borderWidth: "0.5px",
            borderStyle: "solid",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <BuildingSVG color={theme.palette.textColor.main} />
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              نام بازارگاه:{" "}
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            {driverNobatQueueInfo.salonInfo?.name}
          </Typography>
        </Box>
        <Box
          sx={{
            borderColor: blueGrey[100],
            borderWidth: "0.5px",
            borderStyle: "solid",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <PeopleSVG color={theme.palette.textColor.main} />
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              تعداد رانندگان در صف:{" "}
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
              fontWeight: "700",
              fontSize: "16px",
            }}
          >
            {driverNobatQueueInfo?.queueCount}
          </Typography>
        </Box>
        <Box
          sx={{
            borderColor: blueGrey[100],
            borderWidth: "0.5px",
            borderStyle: "solid",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <UserCheckSVG color={theme.palette.textColor.main} />
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              موقعیت شما در صف:{" "}
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
              fontWeight: "700",
              fontSize: "16px",
            }}
          >
            {driverNobatQueueInfo.nobatCode}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "8px",
          }}
        >
          <CustomButton
            // loading={loading}
            onClick={onOk}
            flex={1}
            flexDirection="row"
            title="بله نوبتم لغو شود"
            justifyContent="center"
            bgColor="error.main"
            fSize="16px"
            px="10px"
            py="14px"
            borderRadius="10px"
            // icon1={<CheckCircle size={32} />}
          />
          <CustomButton
            // loading={loading}
            onClick={onDismiss}
            flexDirection="row"
            title="خیر،نوبتم باقی‌بماند"
            borderColor="primary.main"
            textColor="primary.main"
            justifyContent="center"
            bgColor="#fff"
            fSize="16px"
            fWeight="700"
            px="10px"
            py="14px"
            borderRadius="10px"
            icon1={
              <CloseCircleSVG color={theme.palette.primary.main} size={24} />
            }
          />
        </Box>
      </Box>
    </ModalLayout>
  );
}
